import { render, staticRenderFns } from "./InstructorCreatePage.vue?vue&type=template&id=6edd5c2c"
import script from "./InstructorCreatePage.vue?vue&type=script&lang=js"
export * from "./InstructorCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports